import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "content-dashboard" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "reportes mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "reportes__tittle" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Reports by Codes")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "reports__section1 tw-justify-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "" }, " STATE ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select state", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "" }, " COUNTY ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select county", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "reports__button d-flex justify-content-center" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = { class: "reports__data mt-3 pb-3 position-relative" }
const _hoisted_19 = {
  key: 0,
  class: "text-center p-4"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Loading codes data...", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "text-muted mb-0" }
const _hoisted_26 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "STATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COUNTY"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "REALTOR"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MLO"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "TITLE COMPANY"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "INSPECTOR"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "TOTAL USERS")
  ])
], -1)
const _hoisted_28 = { class: "mt-3 p-3 bg-light rounded" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h6", null, "Summary Totals", -1)
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("strong", null, "Realtors:", -1)
const _hoisted_33 = { class: "col-md-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("strong", null, "MLOs:", -1)
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("strong", null, "Title Companies:", -1)
const _hoisted_37 = { class: "col-md-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("strong", null, "Inspectors:", -1)
const _hoisted_39 = { class: "col-md-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "Total Users:", -1)
const _hoisted_41 = {
  key: 2,
  class: "text-center p-4"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, "No codes found for the selected state and county.", -1)
const _hoisted_43 = [
  _hoisted_42
]

import { ref, onMounted, computed } from 'vue';
import TopBar from '@/components/admin/TopBar.vue';
import axios from 'axios';
import { environment } from "@/environment";
import { useToast } from "@/composables/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'counReport',
  setup(__props) {

const toast = useToast();
const loading = ref(false);
const state = ref(null);
const county = ref(null);
const listStates = ref(null);
const listCounties = ref([]);
const codesData = ref([]);
const url = environment.URL_API;

const resetSelections = () => {
  if (!county.value || county.value === null) {
    codesData.value = [];
    return;
  }
};

const totalSummary = computed(() => {
  if (!codesData.value || codesData.value.length === 0) {
    return {
      realtor: 0,
      mlo: 0,
      title_company: 0,
      inspector: 0,
      total_users: 0
    };
  }

  return codesData.value.reduce((acc, item) => {
    acc.realtor += item.realtor || 0;
    acc.mlo += item.mlo || 0;
    acc.title_company += item.title_company || 0;
    acc.inspector += item.inspector || 0;
    acc.total_users += item.total_users || 0;
    return acc;
  }, {
    realtor: 0,
    mlo: 0,
    title_company: 0,
    inspector: 0,
    total_users: 0
  });
});

const getStates = async () => {
  loading.value = true;
  try {
    const response = await axios(
      `${url}realtor-format/get-states`,
      {
        method: "GET",
      }
    );
    if (response.data.success) {
      listStates.value = response.data.states;
    } else {
      toast.error("Error loading states", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    toast.error("Error loading states", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  } finally {
    loading.value = false;
  }
};

const getCountiesByState = async () => {
  if (!state.value || state.value === null) {
    listCounties.value = [];
    county.value = null;
    codesData.value = [];
    return;
  }
  loading.value = true;
  try {
    const response = await axios(
      `${url}realtor-format/get-county?state=${state.value.state}`,
      {
        method: "GET",
      }
    );
    if (response.data.success) {
      listCounties.value = response.data.county;
      county.value = null; 
      codesData.value = []; 
    } else {
      toast.error("Error loading counties", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    toast.error("Error loading counties", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  } finally {
    loading.value = false;
  }
};

const getCodesData = async () => {
  if (!county.value || county.value === null || !state.value) {
    toast.error("Please select both state and county", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    return;
  }

  loading.value = true;
  codesData.value = [];

  try {
    const codesResponse = await axios({
      method: "GET",
      url: `${url}realtor-format/get-codes`,
      params: {
        county: county.value.county,
        state: state.value.state
      }
    });

    if (!codesResponse.data.success || !codesResponse.data.codes) {
      toast.error("Error loading codes", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
      return;
    }

    const codes = codesResponse.data.codes;
    
    const codePromises = codes.map(async (code) => {
      try {
        const response = await axios({
          method: "GET",
          url: `${url}realtor-format/count-users`,
          params: {
            state: state.value.state,
            country: county.value.county,
            code: code
          }
        });

        if (response.data.success) {
          const data = response.data;
          return {
            state: state.value.state,
            county: county.value.county,
            code: code,
            realtor: data.realtors || 0,
            mlo: data.regular_users || 0,
            title_company: data.title_companies || 0,
            inspector: data.inspectors || 0,
            total_users: (data.realtors || 0) + (data.regular_users || 0) + (data.title_companies || 0) + (data.inspectors || 0)
          };
        } else {
          return {
            state: state.value.state,
            county: county.value.county,
            code: code,
            realtor: 0,
            mlo: 0,
            title_company: 0,
            inspector: 0,
            total_users: 0
          };
        }
      } catch (error) {
        console.error(`Error fetching data for code ${code}:`, error);
        return {
          state: state.value.state,
          county: county.value.county,
          code: code,
          realtor: 0,
          mlo: 0,
          title_company: 0,
          inspector: 0,
          total_users: 0
        };
      }
    });

    const results = await Promise.all(codePromises);
    
    codesData.value = results

    if (codesData.value.length === 0) {
      toast.info("No codes found for the selected area", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }

  } catch (error) {
    toast.error("Error loading codes data", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  getStates();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TopBar),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _hoisted_8,
              _withDirectives((_openBlock(), _createElementBlock("select", {
                class: "form-select form-select-sm rounded-pill border-light shadow-sm px-3 py-2",
                style: {"width":"150px"},
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state).value = $event)),
                onChange: getCountiesByState,
                key: 'state-select'
              }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listStates.value, (state) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: state.state,
                    value: state
                  }, _toDisplayString(state.state), 9, _hoisted_10))
                }), 128))
              ], 32)), [
                [_vModelSelect, state.value]
              ])
            ]),
            (state.value !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives((_openBlock(), _createElementBlock("select", {
                    class: "form-select form-select-sm rounded-pill border-light shadow-sm px-3 py-2",
                    style: {"width":"300px"},
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((county).value = $event)),
                    onChange: resetSelections,
                    key: 'county-select'
                  }, [
                    _hoisted_13,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listCounties.value, (county) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: county.county,
                        value: county
                      }, _toDisplayString(county.county), 9, _hoisted_14))
                    }), 128))
                  ], 32)), [
                    [_vModelSelect, county.value]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (getCodesData())),
              disabled: loading.value || !county.value
            }, " GENERATE REPORT", 8, _hoisted_16)
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
              : (codesData.value && codesData.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("h6", null, "Codes Report for " + _toDisplayString(state.value?.state) + ", " + _toDisplayString(county.value?.county), 1),
                      _createElementVNode("p", _hoisted_25, "Total codes: " + _toDisplayString(codesData.value.length), 1)
                    ]),
                    _createElementVNode("table", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codesData.value, (data, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(data.state), 1),
                            _createElementVNode("td", null, _toDisplayString(data.county), 1),
                            _createElementVNode("td", null, _toDisplayString(data.code), 1),
                            _createElementVNode("td", null, _toDisplayString(data.realtor), 1),
                            _createElementVNode("td", null, _toDisplayString(data.mlo), 1),
                            _createElementVNode("td", null, _toDisplayString(data.title_company), 1),
                            _createElementVNode("td", null, _toDisplayString(data.inspector), 1),
                            _createElementVNode("td", null, _toDisplayString(data.total_users), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createTextVNode(" " + _toDisplayString(totalSummary.value.realtor), 1)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createTextVNode(" " + _toDisplayString(totalSummary.value.mlo), 1)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createTextVNode(" " + _toDisplayString(totalSummary.value.title_company), 1)
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createTextVNode(" " + _toDisplayString(totalSummary.value.inspector), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createTextVNode(" " + _toDisplayString(totalSummary.value.total_users), 1)
                        ])
                      ])
                    ])
                  ]))
                : (!loading.value && county.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                  : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})